import { IBlockAppointmentResponse } from "modules/appointment/types/IBlockAppointmentResponse";

export const createBlockAppointmentResponse = (
  blockAppointment?: IBlockAppointmentResponse
) => {
  return {
    blockedAppointmentId: "12345678",
    termOfValidity: "2020-02-10",
    ...blockAppointment,
  };
};
